import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { useField } from "react-final-form";
const STATUSES = ["Active", "Inactive"];
const useStyles = makeStyles((theme) => ({
  selected: { backgroundColor: theme.orange + "!important" },
  container: {
    display: "grid",
    gridTemplateColumns: "150px auto",
    gridGap: 0,
    marginTop: 20,
    marginBottom: 10,
    // marginLeft: 20,
    alignItems: "center",
  },
  textStyle: { fontSize: 16 },
}));
const StatusInput = () => {
  const classes = useStyles();
  let {
    input: { onChange, value: status },
    meta: { touched, error },
  } = useField("status");

  const handleToggle = (_, v) => {
    onChange(v);
  };

  if (!status) {
    onChange("Active");
  }
  return (
    <>
      <Box className={classes.container}>
        <Typography className={classes.textStyle}>Status</Typography>
        <ToggleButtonGroup
          // style={{ width: 200 }}
          exclusive
          defaultValue={"Active"}
          value={status}
          onChange={handleToggle}
        >
          {STATUSES.map((STATUS) => (
            <ToggleButton
              style={{ width: 100, height: 40 }}
              classes={{ selected: classes.selected }}
              value={STATUS}
            >
              {STATUS}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        {error && touched ? (
          <>
            <Box></Box>
            <Typography variant="caption" style={{ color: "red" }}>
              {error}
            </Typography>
          </>
        ) : null}
      </Box>
    </>
  );
};

export default StatusInput;
